import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { DataExtractionService } from '@/infra/services/data-extraction';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';

interface DeleteDataExtractionModelParams {
	organization_id: string;
	company_id: string;
	data_extraction_model_id: string;
}

const Service = DataExtractionService.getInstance();

export const useDeleteDataExtractionModel = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: DeleteDataExtractionModelParams) => Service.destroyModel(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_DATA_EXTRACTION_MODEL_LIST]);
			message.success(I18n.get('Model deleted successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error deleting model'));
		}
	});
};
